import { render, staticRenderFns } from "./AboutBootsRatings.vue?vue&type=template&id=eae59898"
import script from "./AboutBootsRatings.vue?vue&type=script&lang=js"
export * from "./AboutBootsRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports